<template>
    <el-dialog
            :visible.sync="visible"
            title="批量添加"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            width="1500px"
    >
        <el-form>
            <el-form-item
                    label-width="120px"
                    label="选择时间"
                    :rules="{
          required: true,
          message: '日期不能为空',
          trigger: 'change',
        }"
            >
                <el-date-picker v-model="endTime" type="date" placeholder="选择日期">
                </el-date-picker>
            </el-form-item>
        </el-form>
        <div v-for="(dataForm, index) in domains" :key="index">
            <el-row>
                <el-form
                        :model="dataForm"
                        :rules="dataRule"
                        ref="dataForm"
                        size="medium "
                        :label-width="$i18n.locale === 'en-US' ? '240px' : '120px'"
                >
                    <el-col :span="4">
                        <el-form-item
                                label="班级"
                                prop="classId"
                                :rules="{
                required: true,
                message: '班级名称不能为空',
                trigger: 'blur',
              }"
                        >
                            <el-select
                                    v-model="dataForm.classId"
                                    placeholder="请选择班级"
                                    @change="getClassStudentList(index)"
                                    filterable
                            >
                                <el-option
                                        v-for="classManager in classList"
                                        :label="classManager.className"
                                        :value="classManager.id"
                                        :key="classManager.id"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item
                                label="学生"
                                prop="studentId"
                                :rules="{
                required: true,
                message: '学生不能为空',
                trigger: 'blur',
              }"
                        >
                            <el-select
                                    v-model="dataForm.studentId"
                                    placeholder="请选择学生"
                                    @change="getClassStudentList(index)"
                                    filterable
                            >
                                <el-option
                                        v-for="studentInfo in classStudentList"
                                        :label="studentInfo.studentName"
                                        :value="studentInfo.id"
                                        :key="studentInfo.id"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item
                                label="检查项名称"
                                prop="examineItemId"
                                :rules="{
                required: true,
                message: '检查项名称',
                trigger: 'blur',
              }"
                        >
                            <!--  -->

                            <el-select
                                    v-model="dataForm.examineItemId"
                                    @change="getEvaluateItemList(index)"
                                    placeholder="请选择检查项"
                                    filterable
                            >
                                <el-option
                                        v-for="examineItem in examineItemList"
                                        :label="examineItem.examineItemName"
                                        :value="examineItem.id"
                                        :key="examineItem.id"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item
                                label="评价项名称"
                                prop="evaluateItemId"
                                :rules="{
                required: true,
                message: '评价项名称',
                trigger: 'blur',
              }"
                        >
                            <el-select
                                    v-model="dataForm.evaluateItemId"
                                    placeholder="请选择评价项"
                                    @change="getSore(index)"
                                    filterable
                            >
                                <el-option
                                        v-for="evaluateItem in evaluateItemList"
                                        :label="evaluateItem.evaluateItemName"
                                        :value="evaluateItem.id"
                                        :key="evaluateItem.id"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label="评价项分数" prop="evaluateItemName">
                            <el-input
                                    v-model="dataForm.score"
                                    placeholder="评价项分数"
                                    :disabled="true"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label="备注信息" prop="notes">
                            <el-input v-model="dataForm.notes" placeholder="备注信息"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label-width="30px">
                            <el-button type="warning" round @click.prevent="removeDomain(dataForm)"
                            >删除
                            </el-button
                            >
                        </el-form-item>
                    </el-col>
                </el-form>
            </el-row>
        </div>
        <el-form>
            <el-form-item label-width="50px">
                <el-button type="primary" round @click="addDomain" size="medium ">新增</el-button>
            </el-form-item>
        </el-form>
        <template slot="footer">
            <el-button @click="close()">{{ $t('cancel') }}</el-button>
            <el-button type="primary" @click="dataFormSubmitHandle()">{{
                $t('confirm')
                }}
            </el-button>
        </template>
    </el-dialog>
</template>

<script>
export default {
  data () {
    return {
      endTime: '',
      classList: [],
      classStudentList: [],
      examineItemList: [],
      evaluateItemList: [],
      domains: [
        {
          classId: '',
          className: '',
          studentId: '',
          studentName: '',
          examineItemId: '',
          examineItemName: '',
          evaluateItemId: '',
          notes: '',
          score: ''
        }
      ],
      visible: false,
      dataRule: {
        endTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.getClassList()
        this.getExamineItemList()
      })
    },
    removeDomain (item) {
      var index = this.domains.indexOf(item)
      if (index !== -1) {
        this.domains.splice(index, 1)
      }
    },
    addDomain () {
      this.domains.push({
        classId: '',
        className: '',
        studentName: '',
        studentId: '',
        examineItemId: '',
        examineItemName: '',
        evaluateItemId: '',
        notes: '',
        score: ''
      })
    },
    // 获取信息
    getInfo () {
      this.$http
        .get('/classEvaluate/evaluateScore/info/' + this.dataForm.id)
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.dataForm = {
            ...this.dataForm,
            ...res.data
          }
          this.dataForm.img = this.dataForm.imgSrc.split(',')
        })
        .catch(() => {
        })
    },
    isNull (params) {
      if (params === null || params === undefined || params === '') {
        return true
      }
      return false
    },
    // 表单提交
    dataFormSubmitHandle () {
      if (this.endTime === null || this.endTime === undefined || this.endTime === '') {
        this.$message.error('请选择时间')
        return
      }
      var success = true
      var msg = '请选择'
      this.domains.forEach((e, i) => {
        if (this.isNull(e.classId) || this.isNull(e.studentId) || this.isNull(e.evaluateItemId) || this.isNull(e.examineItemId)) {
          msg = this.isNull(e.classId) ? `请选择第${i + 1}行的班级` : this.isNull(e.studentId) ? `请选择${i + 1}学生` : this.isNull(e.evaluateItemId) ? `请选择${i + 1}评价项` : this.isNull(e.examineItemId) ? `请选择${i + 1}检查项` : '请选择'
          success = false
        }
      })
      if (success === false) {
        this.$message.error(msg)
        return
      }
      const date = new Date(this.endTime)
      this.endTime = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate()
      console.log(this.endTime)
      this.$http.post('studentEvaluate/studentEvaluateScore/save/' + this.endTime, this.domains).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.$message({
          message: this.$t('prompt.success'),
          type: 'success',
          duration: 500,
          onClose: () => {
            this.visible = false
            this.domains = [
              {
                classId: '',
                className: '',
                studentId: '',
                studentName: '',
                examineItemId: '',
                examineItemName: '',
                evaluateItemId: '',
                notes: '',
                score: ''
              }
            ]
          }
        })
      }).catch(() => {
      })
    },
    // 获取信息
    getClassList () {
      this.$http
        .get('/classmanage/classmanage/getList')
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.classList = res.data
          console.log(res.data)
        })
        .catch(() => {
        })
    },
    // 获取班级学生
    getClassStudentList (index) {
      const classId = this.domains[index].classId
      this.domains[index].className = this.classList.find(item => item.id === classId).className
      if (classId === null || classId === undefined || classId === '') {
        return this.$message.error('请选择班级')
      }
      this.$http
        .get('/student/student/getMyClassStudentList/' + classId)
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.classStudentList = res.data
        })
        .catch(() => {
        })
      this.getClassStudentName(index)
    },
    // 获取信息
    getExamineItemList () {
      this.$http
        .get('/studentEvaluate/studentExamineItem/getList')
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.examineItemList = res.data
          console.log(res.data)
        })
        .catch(() => {
        })
    },
    // 获取信息
    getEvaluateItemList (index) {
      const id = this.domains[index].examineItemId
      this.domains[index].examineItemName = this.examineItemList.find(item => item.id === id).examineItemName
      if (id === null || id === undefined || id === '') {
        return this.$message.error('请选择检查项')
      }
      this.$http
        .get('/studentEvaluate/studentEvaluateItem/getList/' + id)
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.evaluateItemList = res.data
        })
        .catch(() => {
        })
    },
    getSore (index) {
      const id = this.domains[index].evaluateItemId
      this.domains[index].score = this.evaluateItemList.find(item => item.id === id).score
    },
    getClassName (index) {
      const id = this.domains[index].classId
      this.domains[index].className = this.classList.find(item => item.id === id).className
    },
    getClassStudentName (index) {
      const id = this.domains[index].studentId
      this.domains[index].studentName = this.classStudentList.find(item => item.id === id).studentName
    },
    close () {
      this.visible = false
      this.domains = [
        {
          classId: '',
          className: '',
          studentId: '',
          studentName: '',
          examineItemId: '',
          examineItemName: '',
          evaluateItemId: '',
          notes: '',
          score: ''
        }
      ]
    }
  }
}
</script>
